import loadTableViewFromTableQuery from "../actions/loadTableViewFromTableQuery";
import preserveQueryOnTypeRows from "../helpers/preserveQueryOnTypeRows";
import { onMailSearchComplete } from "owa-mail-actions/lib/mailSearchActions";
import type { LoadTableViewFromSearchTableQueryActionMessage } from "owa-mail-search/lib/actions/publicActions";
import { loadTableViewFromSearchTableQuery } from "owa-mail-search/lib/actions/publicActions";
import { orchestrator } from "satcheljs";
import type { SearchTableQuery } from "owa-mail-list-search";
import { SearchProvider } from "owa-search-service/lib/data/schema/SearchProvider";
import { isGlobalFeatureEnabled } from "owa-feature-flags";
import { type MailRibbonTabId } from "owa-ribbon-ids/lib/mailRibbonId";
import saveSelectedTab from "owa-mail-ribbon-store/lib/actions/saveSelectedTab";
import { getSelectedTableView } from "owa-mail-list-store";

orchestrator(loadTableViewFromSearchTableQuery, async (actionMessage: LoadTableViewFromSearchTableQueryActionMessage) => {
    const { searchTableQuery, searchEndToEndPerformanceDatapoint, actionSource } = actionMessage;
    const selectedTableView = getSelectedTableView();
    const selectedSearchTableQuery = selectedTableView?.tableQuery as SearchTableQuery | undefined;
    const hasQueryOnTypeRows = (selectedTableView?.recentRowKeys?.length ?? 0) > 0 ||
        (selectedTableView?.moreResultsRowKeys?.length ?? 0) > 0;
    if (hasQueryOnTypeRows &&
        (selectedSearchTableQuery?.scenarioType === "queryOnType" ||
            selectedTableView?.hasPreservedQueryOnTypeRows === true ||
            selectedTableView?.hasPreservedQueryOnTypeRecentRows === true)) {
        preserveQueryOnTypeRows(selectedTableView, searchTableQuery as SearchTableQuery);
    }
    
    // Load table view from search table query (makes search requests in here).
    await loadTableViewFromTableQuery(searchTableQuery, searchEndToEndPerformanceDatapoint, actionSource, undefined /*initialSessionData*/);
    
    // Skip the query for a non-mail-entity tabbed search, offline search, UIB search, or PST search,
    // each of which makes its own query
    const searchScenarioType = (searchTableQuery as SearchTableQuery)?.scenarioType;
    const searchProvider = (searchTableQuery as SearchTableQuery)?.searchProvider;
    if (searchScenarioType != "tabbedSearch" &&
        searchProvider !== SearchProvider.Offline &&
        searchProvider !== SearchProvider.PST &&
        searchProvider !== SearchProvider.UnifiedInbox) {
        // Once table view has loaded, dispatch action to notify search completed.
        onMailSearchComplete();
        // Set the ribbon tab to Search
        if (isGlobalFeatureEnabled("sea-searchRibbon")) {
            saveSelectedTab(14..toString());
        }
    }
});
